import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "move2",
  "use": "move2-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 6 10\" id=\"move2\"><path d=\"M0,0L2,0L2,2L0,2L0,0ZM4,0L6,0L6,2L4,2L4,0ZM4,4L6,4L6,6L4,6L4,4ZM4,8L6,8L6,10L4,10L4,8ZM0,4L2,4L2,6L0,6L0,4ZM0,8L2,8L2,10L0,10L0,8Z\" fill=\"#232A35\" fill-opacity=\"0.8500000238418579\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol